var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "users_3_",
    "data-name": "users(3)",
    d: "M5.625,9.75A3.375,3.375,0,1,1,9,6.375,3.375,3.375,0,0,1,5.625,9.75Zm0-5.25A1.875,1.875,0,1,0,7.5,6.375,1.875,1.875,0,0,0,5.625,4.5ZM11.25,15A3.755,3.755,0,0,0,7.5,11.25H3.75A3.754,3.754,0,0,0,0,15v3H1.5V15a2.25,2.25,0,0,1,2.25-2.25H7.5A2.25,2.25,0,0,1,9.75,15v3h1.5Zm1.875-8.25A3.375,3.375,0,1,1,16.5,3.375,3.375,3.375,0,0,1,13.125,6.75Zm0-5.25A1.875,1.875,0,1,0,15,3.375,1.875,1.875,0,0,0,13.125,1.5ZM18,12a3.755,3.755,0,0,0-3.75-3.75h-3v1.5h3A2.25,2.25,0,0,1,16.5,12v3H18Z",
    transform: "translate(0.5 0.5)",
    fill: "#6b87b0",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.cc9a3f223d7b77675a770090655ec23f.svg";
export { ForwardRef as ReactComponent };